'use strict';

var BreadCrumbsCtrl = ['$state', function($state) {
    var _this = this;

    //turn the current view to the department name so as to show pretty name
    this.getDepartmentName = function() {
        if ($state.params.departmentId) {
            return _this.departments.filter(function(department) {
                return department.id === $state.params.departmentId;
            })[0].name || '';
        }
        return;
    };
    
    //we get the current view for the breadcrumbs so as to show if we are viewing forms or teams.
    //Change this if we add newer subsections per department.
    this.getView = function() {
        if ($state.current.name.indexOf('dashboard.forms') > -1) {
            return {
                name: 'Formularios',
                view: 'dashboard.forms',
                departmentId: $state.params.departmentId
            };
        }
        if ($state.current.name.indexOf('dashboard.teams') > -1) {
            return {
                name: 'Equipos',
                view: 'dashboard.teams',
                departmentId: $state.params.departmentId
            };
        }
        if ($state.current.name.indexOf('dashboard.departments') > -1) {
            return {
                name: 'Departamentos',
                view: 'dashboard.departments'
            };
        }
        if ($state.current.name.indexOf('dashboard.users') > -1) {
            return {
                name: 'Usuarios',
                view: 'dashboard.users'
            };
        }
        if ($state.current.name === 'dashboard') {
            return {
                name: null,
                view: 'dashboard',
                departmentId: null
            };
        }
        return 'Sin definir';
    };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            departments: '='
        },
        controller: BreadCrumbsCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard/dashboardBreadCrumbsDirective.html'
    };
};
